export function toSelectOptions(labelsMap, exclude = []) {
  return Object.entries(labelsMap)
    .filter(([value]) => !exclude.includes(value))
    .map(([value, label]) => ({ value, label }));
}

export function toValueOptions(values) {
  return (values || []).map((value) => ({ value, label: value }));
}

export function toLabeledOptions(values, labelsMap) {
  return (values || []).map((value) => ({ value, label: labelsMap[value] || value }));
}

export function stableOptions(owner, cacheKey, sources, build) {
  const cached = owner[cacheKey];
  if (
    cached &&
    cached.sources.length === sources.length &&
    cached.sources.every((source, index) => source === sources[index])
  ) {
    return cached.options;
  }
  const options = build();
  owner[cacheKey] = { sources, options };
  return options;
}
